import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const KEY = "vt-geo";
const LAST = "vt-last-place";
export const APPLIED = "vt-geo-applied";
const IDLE = { status: "idle", geo: null, reason: null, cleared: false };
const GeoCtx = createContext(null);

export const readLast = () => { try { return JSON.parse(localStorage.getItem(LAST) || "null"); } catch { return null; } };
export const rememberPlace = (region, commune) => localStorage.setItem(LAST, JSON.stringify({ region, commune }));

const initial = () => {
  try { return { ...IDLE, ...(JSON.parse(sessionStorage.getItem(KEY) || "null") || {}) }; } catch { return IDLE; }
};

// Detecta la comuna con la ubicación del dispositivo apenas el usuario entra a la plataforma (una vez por sesión).
export function GeoProvider({ children }) {
  const [state, setState] = useState(initial);
  const save = (patch) => setState((s) => {
    const n = { ...s, ...patch };
    sessionStorage.setItem(KEY, JSON.stringify({ ...n, status: n.status === "locating" ? "idle" : n.status }));
    return n;
  });

  const locate = useCallback((manual = false) => {
    if (manual) sessionStorage.removeItem(APPLIED);
    if (!navigator.geolocation) { save({ status: "manual", reason: "unsupported" }); return; }
    save({ status: "locating", reason: null, cleared: false });
    navigator.geolocation.getCurrentPosition(async ({ coords }) => {
      try {
        const { data } = await api.get("/geo/reverse", { params: { lat: coords.latitude, lon: coords.longitude } });
        save({ status: "located", geo: data, reason: null });
      } catch (e) {
        save({ status: "manual", reason: e.response?.status === 404 ? "outside" : "service" });
      }
    }, (err) => {
      save({ status: "manual", reason: err.code === 1 ? "denied" : err.code === 3 ? "timeout" : "unavailable" });
    }, { enableHighAccuracy: false, timeout: 12000, maximumAge: 300000 });
  }, []); // eslint-disable-line

  useEffect(() => {
    if (state.status === "idle") { locate(); }
  }, []); // eslint-disable-line

  const value = {
    ...state,
    locate: () => locate(true),
    clear: () => save({ cleared: true, reason: null }),
    dismiss: () => save({ reason: null }),
  };
  return <GeoCtx.Provider value={value}>{children}</GeoCtx.Provider>;
}

export const useGeo = () => useContext(GeoCtx);
